import { system } from '@/vue/modules/device'

export const css = () => {
  return 'ie' === system.browser || 'safari' === system.browser ? 'css2d' : 'css3d'
}
